import { Select } from 'antd';
import React, { useMemo } from 'react';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import { useGetIdFromName } from '../../common/form/utils';
import { useSystemClassifierSelectOptions } from '../../configuration';
import { SystemClassifierCode } from '../../systemClassifier';
import { ExecutionPeriodsEditFormType } from '../schema';
import { filterAllowed, PeriodOption } from './filterAllowed';

export interface PeriodSelectProps {
  name: FieldPath<ExecutionPeriodsEditFormType>;
  predefined: SystemClassifierCode;
  periodicity: SystemClassifierCode;
}

export function PeriodSelect({
  name,
  periodicity,
  predefined,
}: PeriodSelectProps) {
  const { control } = useFormContext<ExecutionPeriodsEditFormType>();
  const classifiers = useSystemClassifierSelectOptions(
    [periodicity, predefined],
    'code'
  );

  const options = useMemo(() => {
    const periodicityOptions = classifiers[periodicity].map((option) => ({
      ...option,
      type: 'period',
    }));
    const predefinedOptions = classifiers[predefined].map((option) => ({
      ...option,
      type: 'predefined',
    }));

    return predefinedOptions.concat(periodicityOptions);
  }, [classifiers, periodicity, predefined]);

  const getIdFromName = useGetIdFromName();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        const { value } = field;
        const onChange = (
          value: string[],
          option?: PeriodOption | PeriodOption[]
        ) => {
          field.onChange(filterAllowed(option));
        };
        const id = getIdFromName(name);
        return (
          <Select
            id={id}
            mode="multiple"
            onChange={onChange}
            options={options}
            value={value as string[]}
          />
        );
      }}
    />
  );
}
